<template>
    <div class="modal fade top-most not-full-screen" id="timeout-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Your Session is About to Expire</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <p>
                        You will be logged out automatically in <b><span id="seconds_remain"></span> seconds</b>. 
                        Moving your mouse will keep your session active and allow you to continue working
                    </p>
                    <!--<p>Click <b>Logout</b> to log out now, or <b>Continue</b> to continue working</p>-->
                </div>

                <!--
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-logout" data-dismiss="modal">Logout</button>
                    <button type="button" class="btn btn-primary btn-continue" data-dismiss="modal">Continue</button>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimeoutModal',
}
</script>